import React from 'react';
import { HistoryGrid } from '@1823-partners/core';
import { getPricingEntryHistory } from '../api';
import { formatDate } from '../utils/dateUtils';
import { formatPrice4 } from '../utils/priceUtils';

const PricingHistory = ({ asofdt, id2 }) => (
  <HistoryGrid
    fetchHistory={() => getPricingEntryHistory(asofdt, id2)}
    fetchParams={[asofdt, id2]}
    transformData={(data) => data.map(e => ({
      ...e,
      ASOFDT: formatDate(e.ASOFDT),
      RECEIVED_DATE: formatDate(e.RECEIVED_DATE),
    }))}
    fieldNames={{
      ASOFDT: 'As Of Date', BROKER: 'Broker', DESCRIPTION: 'Description',
      EMAIL: 'Email', ID2: 'ID2', PRICE: 'Price',
      RECEIVED_DATE: 'Received Date', USE_PRICE: 'Use Price', NOTES: 'Notes',
    }}
    columns={[
      { field: 'ASOFDT', headerName: 'As Of Date', pinned: 'left' },
      { field: 'BROKER', headerName: 'Broker', pinned: 'left' },
      { field: 'DESCRIPTION', headerName: 'Description' },
      { field: 'EMAIL', headerName: 'Email' },
      { field: 'ID2', headerName: 'ID2' },
      { field: 'PRICE', headerName: 'Price', valueFormatter: p => formatPrice4(p.value) },
      { field: 'RECEIVED_DATE', headerName: 'Received Date' },
      { field: 'USE_PRICE', headerName: 'Use Price' },
      { field: 'NOTES', headerName: 'Notes' },
    ]}
  />
);

export default PricingHistory;
